


































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Tag } from '@/types';
import UBlock from '@/ui-lib/block/Block.vue';
import TagFormView from '@/components/tag/TagForm.vue';
import TagDeleteForm from '@/components/tag/TagDeleteForm.vue';

@Component<TagItemInfoView>({
  components: {
    TagDeleteForm,
    UBlock,
    TagFormView
  }
})
export default class TagItemInfoView extends Vue {
  @Prop({ required: true })
  private tag!: Tag;

  private saved(tg: Tag) {
    this.$emit('saved', tg);
  }

  private deleted() {
    this.$emit('deleted');
  }
}
